import React from 'react';
import { Globe, Lightbulb, BookOpen, CheckCircle, Clock, Target } from 'lucide-react';
import EnhancedMarkdown from './EnhancedMarkDown';

const SynthesisCard = ({ synthesis }) => {
  // CORRECTION : Utiliser le bon champ pour le contenu
  // Le contenu de la synthèse est dans synthesis.extract ou synthesis.content
  const content = synthesis?.extract || synthesis?.content || synthesis?.snippet || '';
  
  console.log('SynthesisCard - Contenu reçu:', {
    hasExtract: !!synthesis?.extract,
    hasContent: !!synthesis?.content,
    hasSnippet: !!synthesis?.snippet,
    contentLength: content.length,
    contentPreview: content.substring(0, 200)
  });

  // Si pas de synthèse, retourner un placeholder
  if (!synthesis) {
    return (
      <div className="text-center text-gray-500 p-6 bg-white rounded-xl shadow-md border border-gray-200">
        <Globe className="w-12 h-12 mx-auto mb-3 text-gray-300" />
        <p>Aucune synthèse disponible</p>
        <p className="text-sm mt-2">Cliquez sur "Générer la synthèse" pour commencer</p>
      </div>
    );
  }

  // Si pas de contenu, afficher un message d'erreur
  if (!content || content.trim() === '') {
    return (
      <div className="text-center text-gray-500 p-6 bg-white rounded-xl shadow-md border border-gray-200">
        <Globe className="w-12 h-12 mx-auto mb-3 text-gray-300" />
        <p>Contenu de synthèse vide</p>
        <p className="text-sm mt-2">Veuillez régénérer la synthèse</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 mb-6">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <Globe className="w-5 h-5 text-blue-600" />
          <h3 className="text-lg font-semibold text-gray-800">
            {synthesis.title || "Synthèse des résultats"}
          </h3>
        </div>
      </div>

      {/* Contenu principal - CORRECTION : Affichage direct du contenu */}
      <div className="p-6">
        <div className="text-gray-600">
          <EnhancedMarkdown content={content} />
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 p-4 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-500 italic">
            Synthèse générée par Intelligence Artificielle pour faciliter votre apprentissage
          </p>
          <p className="text-xs text-gray-400">
            {synthesis.datePublished ? 
              new Date(synthesis.datePublished).toLocaleDateString('fr-FR') : 
              new Date().toLocaleDateString('fr-FR')
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default SynthesisCard;